<template>
  <div v-if="item" v-bind="$attrs">
    <v-tooltip
      v-if="item.desc"
      top
      left
      :disabled="!isLongDescription(item.desc)"
      :open-delay="300"
    >
      <template #activator="{on}">
        <v-chip v-on="on" outlined color="green" :class="{ hasTooltip: isLongDescription(item.desc)}">
          <span class="text-truncate"  style="max-width: 50ch">{{ $filters.getMatchingTranslation({ value: item.desc }) }}</span>
        </v-chip>
      </template>
      {{ $filters.getMatchingTranslation({ value: item.desc }) }}
    </v-tooltip>
    <v-chip v-else outlined color="green"> {{ $t('in-all-other-cases') }}</v-chip>
    <v-icon color="grey" large>mdi-ray-start-arrow</v-icon>
    <v-chip color="orange lighten-5">
        <span v-if="item.conformance === 'NP'" class="px-3">
          {{ conformance(item) }}
        </span>
        <span v-else class="px-3">
          {{ cardinality(item) }}
          {{ conformance(item) }}
        </span>
    </v-chip>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    cardinality () {
      return (item) => this.$filters.getCardinality(item)
    },
    conformance () {
      return (item) => this.$filters.getConformance(item)
    },
    isLongDescription () {
      return value => this.$filters.getMatchingTranslation({ value }).length >= 50
    }
  }
}
</script>
